import * as React from 'react';

import colors from '../../utils/colors';

interface Props {
  tableHeadItem: string;
  preferenceItems: string[];
  preferenceValue: any[];
  percentageOfPreference: number[];
}

function PersonalPreference (props: Props) {

  const {
    percentageOfPreference,
    preferenceValue,
    tableHeadItem,
    preferenceItems,
  } = props;

  return (
    <div
      className='d-flex border-row'>
      <div className='personal-title bold'>
        {tableHeadItem[0].toUpperCase() + tableHeadItem.slice(1).split('_').join(' ')}
      </div>
      <div className='personal-text d-flex flex-wrap justify-evenly'>
        {
          preferenceItems.map((prefItem, key) => {
            return (
              <div
                key={key}
                style={{ marginLeft: '5px' }}
                className='d-flex align-center'>
                <div>{prefItem.toString() + ': '}</div>
                <div className='line-container d-flex'>
                  <div
                    style={{ backgroundColor: colors[key], width: percentageOfPreference[key].toFixed(1) + 'px' }}
                    className='line-load' />
                  <div>
                    {preferenceValue[key]}
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
  
}

export default React.memo(PersonalPreference);
